import DisciplinesFilter from "./DisciplinesFilter";


export default DisciplinesFilter;